<template>
    <div class="template-list-widget">
        <div class="widget-body">
            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="is_loading" :is-full-page="false"
                :can-cancel="false" background-color="#fff" class="loader"></loading>

            <div class="widget-section" ref="template_list">
                <div class="template-item" v-for="(item, index) in templateList" :key="index">
                    <div class="template-header" :class="{ menuActive: item.menu }">
                        <widgetDropdown v-model="item.menu" :right="true" :hover="false" :interactive="true">
                            <button class="btn-dropdown btn-menu">
                                <img class="icon" style="height: 20px" src="@/assets/cv-editor-icons/menu-dot.svg" />
                            </button>
                            <div slot="dropdown" class="dropdown-widget" style="right: -9px">
                                <a class="dropdown-item" href="#" @click="duplicateTemplate(item)"> Duplicate </a>
                                <a class="dropdown-item" href="#" @click="exportTemplateAsJson(item)"> Export Json </a>
                                <app-dialog v-if="active_tab == 1" title="Delete Template"
                                    ask="Are you sure you want to permanently delete template?" yesText="Delete"
                                    noText="Cancel" @onComfirm="deleteTemplate(item)">
                                    <a class="dropdown-item" href="#">Delete </a>
                                </app-dialog>
                            </div>
                        </widgetDropdown>
                    </div>
                    <div class="template-img">
                        <img @click.prevent="loadAsTemplate(item, 'edit')"
                            :src="$fullUrl('images/profiles/' + item.thumb)" />
                        <div class="default-cv" v-if="item.default">Default CV</div>
                    </div>
                    <div class="template-name">{{ item.name }}</div>
                </div>
                <div class="add-temp-widget" v-if="active_tab == 1" @click="createNewTemplate()">
                    <img src="@/views/Resume/icons/add-box-line.svg" />
                    <p>Create New Template</p>
                </div>
            </div>
        </div>

        <!-- Rename template modal -->
        <widgetModal v-if="show_rename_template_form" title="Rename Template" subtitle="Fill in the information below "
            btnlefttext="Save Changes" btncentertext="Cancel" btnrighttext="" :hiderightbtn="true"
            :leftloading="save_template_loading" :rightloading="false" :centerloading="false" :footerhidden="false"
            footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="550px"
            @onLeftClick="renameTemplate()" @onCenterClick="show_rename_template_form = false">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Template name">
                        <widgetInput type="text" v-model="renameForm.name" placeholder=""></widgetInput>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-menu",
    components: {},
    props: {
        active_tab: {
            type: Number,
            default: 1,
        },
        activeTab: {
            type: Object,
            default: null,
        },
        account_type: {
            type: String,
            default: "school",
        },
    },
    data() {
        return {
            selected_template: null,
            templateList: [],
            show_rename_template_form: false,
            save_template_loading: false,
            renameForm: { id: null, name: "" },
            active_template_tab: 1,
            is_loading: false,
        };
    },
    computed: {},
    watch: {},
    mounted() {
        let vm = this;
        eventBus.$on("loadEditorTemplate", (data) => {
            vm.getTemplateData("mine");
        });
        vm.getTemplateData("mine");
    },
    methods: {
        duplicateTemplate(item) {
            let vm = this;
            item.menu = false;
            vm.$emit("duplicateTemplate", item);
        },
        exportTemplateAsJson(item) {
            let vm = this;
            item.menu = false;
            const jsonStr = item.cvData;
            const dataUri =
                "data:application/json;charset=utf-8," + encodeURIComponent(jsonStr);
            const exportFileDefaultName = item.name + ".json";
            const linkElement = document.createElement("a");
            linkElement.setAttribute("href", dataUri);
            linkElement.setAttribute("download", exportFileDefaultName);
            linkElement.click();
        },
        createNewTemplate() {
            let vm = this;
            vm.$emit("createNewTemplate");
        },
        loadAsTemplate(item, type) {
            let vm = this;
            item.menu = false;
            vm.$emit("loadAsTemplate", item);
        },
        showRenameModal(item) {
            let vm = this;
            vm.renameForm = { id: item.id, name: item.name };
            vm.show_rename_template_form = true;
        },
        deleteTemplate(item) {
            let vm = this;
            item.menu = false;
            vm.$store
                .dispatch("CVS_DELETE_TEMPLATE", { id: item.id, type: vm.account_type })
                .then((response) => {
                    vm.getTemplateData();
                    vm.$notify({
                        group: "status",
                        title: "Messsage",
                        text: "Template deleted",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        renameTemplate() {
            let vm = this;
            vm.save_template_loading = true;
            eventBus.$set(vm.renameForm, "type", vm.account_type);
            vm.$store
                .dispatch("CVS_RENAME_TEMPLATE", vm.renameForm)
                .then((response) => {
                    vm.save_template_loading = false;
                    vm.show_rename_template_form = false;
                    vm.getTemplateData("mine");
                    vm.$notify({
                        group: "status",
                        title: "Messsage",
                        text: "Template renamed",
                        type: "success",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    vm.save_template_loading = false;
                    vm.$notify({
                        group: "status",
                        title: "Message",
                        text: "Something went wrong",
                        type: "warn",
                        duration: 3000,
                    });
                    console.error({ error });
                });
        },
        getTemplateData(type) {
            let vm = this;
            vm.is_loading = true;
            vm.$store
                .dispatch("CVS_GET_TEMPLATES", {
                    filter: type,
                    type: vm.account_type,
                })
                .then((response) => {
                    vm.is_loading = false;
                    vm.templateList = response.data.map((item) => {
                        item.menuActive = false;
                        return item;
                    });
                    eventBus.$on("getAppliedCv", (callback) => {
                        if (vm.account_type == "school") {
                            let appliedCv = vm.templateList.find((item) => {
                                return item.default;
                            });
                            callback(appliedCv);
                        } else {
                            callback(vm.selected_template);
                        }
                    });
                })
                .catch((error) => {
                    vm.is_loading = false;
                    console.error({ error });
                });
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-list-widget {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 5px;

    .widget-body {

        &.noScoll {
            overflow-y: hidden !important;
        }

        .widget-section {
            display: grid;
            grid-template-columns: 48% 48%;
            grid-gap: 10px;
            width: 100%;

            .add-temp-widget {
                background: #fff;
                border: 1px solid #1BA5A4;
                box-sizing: border-box;
                border-radius: 5px;
                height: 200px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                cursor: pointer;
                padding: 10px;

                img {
                    width: 25px;
                }

                p {
                    color: #1BA5A4;
                    text-align: center;
                }
            }

            .template-item {
                box-sizing: border-box;
                border-radius: 5px;
                height: 200px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                position: relative;
                cursor: pointer;

                &.applied {
                    border: 2px solid #1ba5a4;
                }

                .template-header {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    right: 0px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    padding-top: 10px;
                    padding-right: 6px;
                    background: black;
                    background: linear-gradient(180deg,
                            rgba(0, 0, 0, 0.5) 9%,
                            rgba(255, 255, 255, 0) 97%);
                    z-index: 99;
                    height: 50px;
                    transition: all 0.5s ease;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;

                    &.menuActive {
                        z-index: 9999;
                    }
                }

                &:hover {
                    .template-header {
                        transition: all 0.5s ease;
                        top: 0px;
                    }
                }

                .template-img {
                    height: calc(100% - 40px);
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    border-radius: 5px;
                    overflow: hidden;
                    border: 1px solid #d6e0ea;

                    img {
                        width: 100%;
                        object-fit: cover;
                        height: 100%;
                    }

                    .default-cv {
                        position: absolute;
                        bottom: 0px;
                        background: #1ba5a4;
                        left: 0px;
                        right: 0px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 29px;
                        color: #fff;
                    }
                }

                .template-name {
                    padding-top: 10px;
                    height: 40px;
                    font-size: 12px;
                    overflow: hidden;
                    display: block;
                    -webkit-line-clamp: 2;
                    display: box;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                    white-space: normal;
                }
            }
        }
    }
}
</style>